module.exports = __webpack_public_path__ + "assets/posteriorStaticBackground.eaf55d65877b384d896c5874c1968855.jpg";